export default __webpack_public_path__ + "static/media/message-icon.4dc1569e.svg";